module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "List"
  }, [
    [_c('vfilter', {
      attrs: {
        "template": "participants",
        "data": _vm.filter
      },
      on: {
        "FILTER_CHANGE": _vm.onChange,
        "FILTER_CHANGE_PAYLOAD": _vm.onChangePayload
      }
    }), _vm._v(" "), _c('default', {
      attrs: {
        "data": _vm.api_response,
        "merge": _vm.merge_items,
        "locked": _vm.locked
      }
    })], _vm._v(" "), _c('pager', {
      attrs: {
        "total": _vm.totalPagesCount,
        "current": _vm.currentPageNumber,
        "locked": _vm.locked
      },
      on: {
        "goto": _vm.goto
      }
    }, [_vm._v("\n\t\t" + _vm._s(_vm.loadMoreText) + "\n\t")])
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34b9e480"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/List.vue
// module id = 260
// module chunks = 37